
import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DealerSearchRequestModel } from '../business-entities/dealer-search-request-model.interface';
import { SelectDealerData } from '../data-services/select-dealer-data.service';

@Injectable({ providedIn: 'root' })
export class SelectDealer {
    constructor(private sdDataService: SelectDealerData) { }

    GetAllDealerDetails(model: DealerSearchRequestModel): Promise<GenericResponse<any>> {
        return this.sdDataService.GetAllDealerDetails(model);
    }

    GetDealerRentalCars(dealerId: string): Promise<GenericResponse<any>> {
        return this.sdDataService.GetDealerRentalCars(dealerId);
    }
    GetGenericRentalCars(languageId: string): Promise<GenericResponse<any>> {
      return this.sdDataService.GetGenericRentalCars(languageId);
    }
    GetAdditionalServices(dealerId: string,languageId: string): Promise<GenericResponse<any>> {
        return this.sdDataService.GetAdditionalServices(dealerId,languageId);
    }

  GetCustomerWaitingLimit(model: any): Promise<GenericResponse<any>> {
    return this.sdDataService.GetCustomerWaitingLimit(model);
  }

  GetDealerCapacity(model: any): Promise<GenericResponse<any>> {
    return this.sdDataService.GetDealerCapacity(model);
  }

  GetMechanicSlots(model: any): Promise<GenericResponse<any>> {
    return this.sdDataService.GetMechanicSlots(model);
  }

  GetSplitMechanicSlots(model: any): Promise<GenericResponse<any>> {
    return this.sdDataService.GetSplitMechanicSlots(model);
  }

  ReserveSlot(model:any):Promise<GenericResponse<any>> {
    return this.sdDataService.ReserveSlot(model);
  }

  GetServicesByDealerId(dealerId: string, language: string,Brand:string,VehicleType:string,FuelType:string,Mileage:number,VehicleAge:number): Promise<any> {
    return this.sdDataService.GetServicesByDealerId(dealerId, language,Brand,VehicleType,FuelType,Mileage,VehicleAge);
  }

  CheckReserveSlotAvailability(model:any):Promise<GenericResponse<any>> {
    return this.sdDataService.CheckReserveSlotAvailability(model);
  }
}
